import MobileTitleBar from "components/MobileTitleBar"
import React, { Component, Fragment, useEffect, useState, useRef } from "react"
import { Container, Image, Button, Table,Icon , Modal} from "semantic-ui-react"
import WordPressContainer from "WordPressContainer"
import shop from "shop/shop"
import Responsive from "react-responsive"
import Slider from "components/Slider/Slider"
import ProductCard     from "components/Product/ProductCard"
import _            from "lodash"
import productStore from "stores/productStore"
import categoryStore from "stores/categoryStore"
import cmsStore from "stores/cmsStore"
import settingStore from "stores/settingStore"
import queryString                                                                                   from "qs"
import { observer }                                              from "mobx-react"
import ProductList                                                                    from "components/Product/ProductList"
import "style/HomePageV2.scss"
import CategoryShortcuts                                                                             from "plugin/CategoryShortcuts/CategoryShortcuts"
import CategorySliderV2                                                                             from "plugin/CategoryShortcuts/CategorySliderV2"
import CategorySlider                                                                             from "plugin/CategoryShortcuts/CategorySlider"
import SliderHomePage from "../components/Slider/SilderHomePage"
import { Link, NavLink }                                         from "react-router-dom"
import NewCustomerContactPage from "./NewCustomerContactPage"
import HeroSection from "../components/Slider/HeroSection"
import ImgBanner from "../components/Slider/SliderFading"
import languageStore               from "stores/languageStore"
import htmr                                                                           from "htmr";
import { InView } from "react-intersection-observer";
import { invalid } from "moment"
import Tooltips from "../components/Tooltips/Tooltips"



@observer
export default class HomePageV2 extends Component {

    state = {
        loading: false,
        activeAboutUs: false,
        products: [],
        productsForList:[],
        categoryIdforCards: settingStore.get("orderMode") === "laboratory" ? "40" : "49",
        orderModeState: settingStore.get("orderMode"),
        customerRegister: false,
        showNewsLetterConsent: localStorage.getItem("newsLetterCheckup") === "true" ? true : false,
        showToolTip: localStorage.getItem("homePageToolTip") === "true" ? true : false,
    }
    async componentDidMount() {
        await this.load(this.props, "medicine");
        await this.load(this.props, "laboratory");
        localStorage.setItem("homePageToolTip", "true");
        //localStorage.setItem("newsLetterCheckup", "false");
    }


    async loadCategoriesForCards() {

    }
    

    load = async ( props = this.props, orderMode ) => {
        let lastFilter = false
        this.setState( { loading: true } )
        const query = queryString.parse( props.location.search.substr( 1 ) )
        const { categories = "" } = props.match.params
        const parentCategories = categories.split( "/" )
        const categoryId = parentCategories.pop()
        const category = categoryStore.categoriesById.get( orderMode === "laboratory" ? 40 : 49)
        
        // TODO: NOT EVERY CATEGORY STORE SUPPORTS THIS 
        // categoryStore.fetchCategoryMeta && categoryStore.fetchCategoryMeta( categoryId )
        
        const { page = 1, count = shop.config.standards.ITEMS_PER_PAGE } = query
        let filters = []
        const fields = _.pick( query, shop.config.pickFilter )
        const filterSize = _.size( fields )
        
        _.forEach( fields, ( value, key ) => {
          
          // MULTIFILTERS ARE ADDED AS "OR"
          if ( Array.isArray( value ) ) {
            let queryFilters = value.map( v => {
              return {
                op: "equals", extra: true, field: key, value: v
              }
            } )
            
            let combinedFilter = { "or": queryFilters }
            filters.push( combinedFilter )
            
          } else {
            let filter = {
              op: "equals", extra: true, field: key, value: value
            }
            filters.push( filter )
          }
        } )
        
        // Only hide variants if we don't search by filter
        // i.e. user searches for color only available on variants
        if ( cmsStore.config.plugin.hideVariants ) {
          // FILTER ALL VARIANTS (ONLY MAIN-ARTCILES)
          let noVariants = {
            op: "equals", field: "type", value: "1"
          }
          const singleItems = { "field": "mainArticle", "op": "equals", "value": "" } //CollectionPage mainArticle = mainart
          let combinedFilter = [{ "or": [singleItems, noVariants] }]
          filters = filters.concat( combinedFilter ) // this shows only mainarticles (i.e. no-variants))
        }
        
        
        if ( categoryId ) {
          this.fetchCategoryPage( categoryId )
          
          productStore.fromCategory( categoryId, {
            value: "%%",
            dir: query.dir || shop.config.standards.DIR || "des",
            sort: query.sort || shop.config.standards.SORT || "sort",
            page,
            count: count || shop.config.standards.ITEMS_PER_PAGE,
          }, filters ).then( res => {
            if ( !res.products.length ) {
              
              let catQuery = {
                value: "%%",
                dir: query.dir || shop.config.standards.DIR || "des",
                sort: query.sort || shop.config.standards.SORT || "sort",
                page,
                count: count || shop.config.standards.ITEMS_PER_PAGE,
              }
              
              let additionalFilters = filters.filter( e => e.field !== "type" )
              
              // console.info( "NO VARIANTS FOUND - FALLBACK TO 'SHOW ALL'" )
              return productStore.fromCategory( categoryId, catQuery, additionalFilters )
                                 .then( res => {
                                   let { products } = res
                                   if ( products.length === 0 ) {
                                     if ( products.length === 0 && shop.config.collections.showProductsFromSubCategories ) {
                                       // get products from all child categories
                    
                                       const mapChildren = cat => {
                                         if ( cat.children.length > 0 ) return _.map( cat.children, mapChildren )
                                         return cat.map_id
                                       }
                    
                                       const ids = _.flatten( category && category.children.map( mapChildren ) )
                                       if ( ids.length > 0 ) {
                                         return productStore.fromCategory( ids, catQuery, additionalFilters )
                                       }
                                     }
                                   }
                                   return res
                                 } )
            }
            return res
          } )
                      .then( res => {
                        let { products, meta = {}, fields, size } = res
                        fields = fields || meta.fields
                       // console.log( "NEW FILTER FIELDS", categoryId, Object.keys( fields ).length, { fields } )
                        this.setState( { products, category, fields, size, meta, filterCount: fields && fields.length, loading: false } )
                        return res
                      } )
        } else {
          productStore.query( {
                                value: "%%",
                                filter: [...filters],
                                dir: query.dir || shop.config.filter_defaults.sort || "des",
                                sort: query.sort || shop.config.filter_defaults.sort,
                                page,
                                count: count || shop.config.standards.ITEMS_PER_PAGE,
                              } )
                      .then( res => {
                        lastFilter = this.props.location.search
                        let { products, size } = res
                        this.setState( { products, size, filterCount: fields && fields.length, loading: false } )
                      } )
        }
      }

    

    render() {
        //console.log("shop", shop)
        const { products, loading, category, fields, size, categoryIdforCards, orderModeState, customerRegister, showNewsLetterConsent, activeAboutUs, showToolTip } = this.state
        
        //console.log("products", products, loading, category, fields, size)
        //const productsForList = products.map(product => product.map_id);
        let baseUrl = (process.env.BSHOP_BASE_URL || process.env.REACT_APP_API)
        console.log("BASEURL", baseUrl)
        const productsForList = ["ART-10111","ART-10112","ART-10113","ART-10114","ART-10115","ART-10116","ART-10117","ART-10118",];
        const { currentLanguage } = languageStore
        console.log("showNewsLetterConsent", showNewsLetterConsent, showToolTip)
        const orderMode = orderModeState
        const categoryforCards1 = [];
        categoryStore.categories.forEach(category => {
            if (!categoryforCards1.children) {
          categoryforCards1.children = [];
            }
            categoryforCards1.children.push(category);
        });
        //const categoryforCardsLaboratory = categoryStore.categoriesById.get( "Outdoorvasen" )
        console.log("CAT", categoryforCards1, shop.config)

        if(shop.config && shop.config.bShop_Theme && shop.config.bShop_Theme.bshop_frontend_theme == "QuickOrderPlus") {
          this.props.history.push("/quickorder")
        }

        return (
            <div >
                {/*                      <WordPressContainer slug="startseite" insertAfter={{
                         3: <Fragment></Fragment> }}/> */}
               {/*style={{ width: "100vw", overflow: "hidden" }} */}
                    {/*Newsletter Banner */}
        {!showToolTip && <Tooltips toolTipToBeShown={"homePageToolTip"}  />}
        {!showNewsLetterConsent && shop.session && shop.config.plugin.newsletterContact && <Fragment>
           <div className="backgroundNewsLetter"
                  style={{
            display: "block",
            position: "fixed",
            bottom: "0%",
            left: "0%",
            width: "100%",
            height: "100%",
            zIndex: 5000,
            background: "rgba(54, 150, 120, 0.4)", // opacity 0.4
            border: "1px solid #ccc",
          }}
        ><div className=" ">
          <Responsive minWidth={900}>
          <div
          className="newsletter-consent-banner"
          style={{
            display: "block",
            position: "fixed",
            bottom: "30%",
            left: "50%",
            transform: "translateX(-50%)",
            zIndex: 5001,
            background: "white",
            border: "1px solid #ccc",
            boxShadow: "0 0 10px rgba(0,0,0,0.1)",
            maxWidth: "1050px",
            minWidth: "900px",
            minHeight: "350px",
            maxHeight: "350px",
            textAlign: "left",
            backgroundColor: "#F8F7EC",
            animation: "fadeIn 0.5s",
          }}
        ><div className="pa">
             {console.log("newsletter", showNewsLetterConsent)}
            <div className="relative">
              <div className="absolute top-1 right-1">
                <button onClick={() => { localStorage.setItem("newsLetterCheckup", "true"); this.setState({ showNewsLetterConsent: localStorage.getItem("newsLetterCheckup") }) }} style={{ height: "35px", width: "40px", border: "0px solid black", backgroundColor: "#346E5B", }}><Icon className="pl1 white close"></Icon></button>
              </div>
              <div style={{ position: "fixed", bottom: "45%", right: "5%", }}><Link to={"/account/?referer=_newsletter"}><Button onClick={() => { localStorage.setItem("newsLetterCheckup", "true"); this.setState({ showNewsLetterConsent: false }) }}
                style={{ minWidth: "280px", height: "50px", borderRadius: "35px" }} primary>{translate("Newsletter Anmeldung absenden")}</Button></Link></div>
              <div className="pa5">
              <p className="black-40 fw6 f4">{translate("Newsletter Anmeldung")}</p>
              <p className="f2 fw6"><div><span >{translate("Neues entdecken.")}</span></div>
              <div><span >{translate("Informiert bleiben.")}</span></div></p>
              <p className="fw5">{translate("Immer einen Schritt voraus – mit unseren Produktnews:")}</p>
              <div className="flex flex-row justify-start pt3">
                <div style={{background: "#C9EADF", borderRadius: "35px", width: "140px", height: "30px", marginRight: "5px"}}><p style={{color: "#346E5B", display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", height: "100%" }} className="fw6">{translate("neue Produkte")}</p></div>
                <div style={{background: "#C9EADF", borderRadius: "35px", width: "160px", height: "30px", marginRight: "5px"}}><p style={{color: "#346E5B", display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", height: "100%" }} className="fw6">{translate("Produkthighlights")}</p></div>
                <div style={{background: "#C9EADF", borderRadius: "35px", minWidth: "180px", height: "30px", marginRight: "5px"}}><p style={{color: "#346E5B", display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", height: "100%" }} className="fw6">{translate("Unternehmens-News")}</p></div>
                <div style={{background: "#C9EADF", borderRadius: "35px", width: "120px", height: "30px", marginRight: "5px"}}><p style={{color: "#346E5B", display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", height: "100%" }} className="fw6">{translate("Aktionen")}</p></div>
              </div></div>
            </div></div>
          </div></Responsive>
          <Responsive maxWidth={899}>
                      <div
          className="newsletter-consent-banner"
          style={{
            display: "block",
            position: "fixed",
            bottom: "30%",
            left: "50%",
            transform: "translateX(-50%)",
            zIndex: 5001,
            background: "white",
            border: "1px solid #ccc",
            boxShadow: "0 0 10px rgba(0,0,0,0.1)",
            maxWidth: "400px",
            minWidth: "400px",
            minHeight: "450px",
            maxHeight: "450px",
            textAlign: "left",
            backgroundColor: "#F8F7EC",
            animation: "fadeIn 0.5s",
          }}
        ><div className="pa">
             {console.log("newsletter", showNewsLetterConsent)}
            <div className="relative">
              <div className="absolute top-1 right-1">
                <button onClick={() => { localStorage.setItem("newsLetterCheckup", "true"); this.setState({ showNewsLetterConsent: localStorage.getItem("newsLetterCheckup") }) }} style={{ height: "35px", width: "40px", border: "0px solid black", backgroundColor: "#346E5B", }}><Icon className="white close"></Icon></button>
              </div>
              
              <div className="pa5 tc">
              <p className="black-40 fw6 f4">{translate("Newsletter Anmeldung")}</p>
              <p className="f3 fw7"><div><span >{translate("Neues entdecken.")}</span></div>
              <div><span >{translate("Informiert bleiben.")}</span></div></p>
              <p className="fw5 f4">{translate("Immer einen Schritt voraus - mit unseren Produktnews")}:</p>
              <div className="flex flex-row justify-center pt3">
                <div style={{background: "#C9EADF", borderRadius: "35px", width: "140px", height: "30px", marginRight: "5px"}}><p style={{color: "#346E5B", display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", height: "100%" }} className="fw6">{translate("neue Produkte")}</p></div>
                <div style={{background: "#C9EADF", borderRadius: "35px", width: "160px", height: "30px", marginRight: "5px"}}><p style={{color: "#346E5B", display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", height: "100%" }} className="fw6">{translate("Produkthighlights")}</p></div>
              </div>
              <div className="flex flex-row justify-center pt3 pb4">
                <div style={{background: "#C9EADF", borderRadius: "35px", minWidth: "180px", height: "30px", marginRight: "5px"}}><p style={{color: "#346E5B", display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", height: "100%" }} className="fw6">{translate("Unternehmens-News")}</p></div>
                <div style={{background: "#C9EADF", borderRadius: "35px", width: "120px", height: "30px", marginRight: "5px"}}><p style={{color: "#346E5B", display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", height: "100%" }} className="fw6">{translate("Aktionen")}</p></div>
              </div>
              <Link to={"/account/?referer=_newsletter"}><Button onClick={() => { localStorage.setItem("newsLetterCheckup", "true"); this.setState({ showNewsLetterConsent: false }) }}
                style={{ minWidth: "280px", height: "50px", borderRadius: "35px" }} primary>{translate("Newsletter Anmeldung absenden")}</Button></Link>
                </div>
            </div></div>
          </div>
            </Responsive>
            </div>
            </div></Fragment>}
        {shop.config && shop.config.bShop_Theme && shop.config.bShop_Theme.bshop_frontend_theme == "BaseTheme" &&
            <Fragment>
            {<div className="headerImageV2 relative">
              <div className="headerImageV2--content relative">
                <div className="headerImageV2--content-text">
                  <p className="f1 fw6 white">
                    {htmr(translate("Startseitenmeldung"))}
                  </p>
                  <p className="f3 fw5 white-80">
                    {htmr(translate("Startseitenmeldung_2"))}
                  </p>
                  <p>
                    <Button as={"a"} href={"//trend-soft.de/produkte/bshop"} id="moreInfoButton" primary><p className="fw5 f4" style={{textDecoration: "none"}}>{translate("Mehr erfahren")}</p> </Button>
                  </p>
                  </div>
                </div>
              </div>}

            {<section className="container pb3 pt5 sectionBenefitsV2">
              <div className="benefitsV2">
                <p><Icon name={"big clone iconColorBenefits"}/></p>
                <div className="pt3 fw7 f3" style={{ textAlign: "center"}}>{htmr(translate("benefit_1"))}</div>
                <div className="pt3 fw4 f5 black-50" style={{ textAlign: "center"}}>{htmr(translate("benefit_1_desc"))}</div>
              </div>
              <div className="benefitsV2">
                <p><Icon name={"big shield iconColorBenefits"}/></p>
                <div className="pt3 fw7 f3" style={{ textAlign: "center"}}>{htmr(translate("benefit_2"))}</div>
                <div className="pt3 fw4 f5 black-50" style={{ textAlign: "center"}}>{htmr(translate("benefit_2_desc"))}</div>
              </div>
              <div className="benefitsV2">
                <p ><Icon name={"big phone iconColorBenefits"}/></p>
                <div className="pt3 fw7 f3" style={{ textAlign: "center"}}>{htmr(translate("benefit_3"))}</div>
                <div className="pt3 fw4 f5 black-50" style={{ textAlign: "center"}}>{htmr(translate("benefit_3_desc"))}</div>
              </div>
            </section>}

              <section className="container pt5 pb3 sectionBenefitsV2">
                <div className="backgroundImageTrendsoftBshop"></div>
                <div className="descriptionTrendsoftBshop">
                  <p className="f2 fw7">{translate("TRENDSOFT DEMOSHOP")}</p>
                  <p className="f4 fw4 black-50">
                    {translate("Dieser Demoshop zeigt typische Funktionen des Trendsoft bShop. Alle Artikel, Preise und Bestellungen sind Beispieldaten.")}
                  </p>
                  <p className="pt2">
                    <Button as={"a"} href={"//trend-soft.de/produkte/bshop"} primary ><p className="fw5 f4">{translate("Mehr erfahren")}</p> </Button>
                  </p>
                </div>
              </section>
            <section className="container pb4 pt5">
                
                <Responsive minWidth={1200}>
                  <p className="f2 fw7 pt2">{translate("Topseller")}</p>
                {<ProductList
                count={4}
                start={0}
                list={productsForList}
                displayMode={"cards"}
                repeat={ProductCard} />}
                </Responsive>
                <Responsive maxWidth={1199} minWidth={900}>
                  <p className="pl3 pr3 f2 fw7 pt2">{translate("Topseller")}</p>
                {<ProductList
                count={4}
                start={0}
                list={productsForList}
                displayMode={"tablet"}
                repeat={ProductCard} />}
                </Responsive>
                <Responsive maxWidth={899}>
                  <div className="flex flex-column items-center">
                  <p className="pl3 pr3 f2 fw7 pt2">{translate("Topseller")}</p>
                {<div className="pl5 pr5 tc flex flex-column items-center justify-center"><ProductList
                count={4}
                start={0}
                list={productsForList}
                displayMode={"mobile"}
                repeat={ProductCard} /></div>}
                </div>
                </Responsive>
            </section>

              <section className="container pt5 pb5">
                <p className="fw7 f2">{translate("Kategorien")} </p>
                  <CategorySliderV2 categoryforCards1={categoryforCards1} translate={translate} />
              </section>

            {shop.config.plugin.newsletterContact && <section className="container pb5 pt5">
              <div className="newsLetterSection">
                <p className="f2 fw7 pt2 pb3">{translate("Subscribe")}</p>
                <p className="f3 fw4 black-50" style={{ textAlign: "center"}}>{translate("Bleiben Sie stehts auf dem Laufenden mit den neusten Informationen und Angeboten.")}</p>
                <input id="newsLetterMail" type="email" placeholder={translate("Ihre E-Mail Adresse")} className="newsLetterInput mt4 mb3 pa3" />
                <Button primary style={{ minWidth: "200px", height: "50px", borderRadius: "35px" }}><p className="fw5 f4">{translate("Absenden")}</p> </Button>
             </div>
              </section>}
              
              </Fragment>}
            {shop.config && shop.config.bShop_Theme && shop.config.bShop_Theme.bshop_frontend_theme == "TimelessClassic" &&
            <Fragment>
              <div className="backgroundImageBannerShop">
              <div className="sliderBanner--content">
                <div className="sliderBanner--content-text">
                  <p className="f2 fw6">
                    {htmr(translate("Startseitenmeldung"))}
                  </p>
                 <p className="f4 fw6 white-70">
                    {htmr(translate("Startseitenmeldung_2"))}
                  </p>
                  <p>
                    <Button id="moreInfoButton" primary style={{

                  }} 
                  className="mt4"
                  as={"a"} href="//www.trend-soft.de/produkte/bshop"
                   >
                   <p className="f4 fw5">{translate("Mehr erfahren")}
                  </p>
                  </Button>
                  </p>
                </div>
              </div>
            </div>
            <section className="container pb4 pt5 bb b--black-10 sectionBenefits">
                
            <Responsive minWidth={1200}>
              <div className="benefitsDiv">
                <div className="fw6 f4 pt3">
                  <div className="tc">
                <div className="tc pa2 pb3">{translate("Jetzt kostenlos registrieren")}</div>
                <Button
                  style={{ minWidth: "280px", height: "50px", borderRadius: "35px" }}
                  as={Link}
                  to={`/login/?referrer=${document.location.pathname}register`}
                  primary
                  target="_blank"
                  rel="noopener noreferrer"
                ><p className="tc" style={{ margin: 0, display: "flex", alignItems: "center", height: "100%", justifyContent: "center" }}>
                  <Icon name={"large white file text"}/>{translate( "Neukunde" )}
                </p>
                 
                </Button></div>
                <div className="tc pt4">
                <div className="tc pa2 pb3">{translate("BestandskundeFrage")}</div>
                <Button
                  style={{ minWidth: "280px", height: "50px", borderRadius: "35px" }}
                  onClick={() => this.setState({ customerRegister: true })}
                  primary
                ><p className="tc" style={{ margin: 0, display: "flex", alignItems: "center", height: "100%", justifyContent: "center" }}>
                  <Icon name={"large white file text"}/>{translate( "Zugang anfordern" )}</p>
                </Button></div>
               <Modal centered={true} dimmer={"blurring"} style={{ borderRadius: 20, zIndex: 999, marginTop: "20%"}} className="ModalLoginPage"  open={customerRegister} onClose={() => this.setState({ customerRegister: false})}>
							<Modal.Header>
							<div className="flex flex-row justify-between items-center">
								<div>{translate( "Zugang anfordern" )}</div>
								<Button basic circular
										onClick={() => {
										this.setState({ customerRegister: false})
										}}
										icon="times"
								/>
							</div>
							
							</Modal.Header>
							<Modal.Content>
										<NewCustomerContactPage closeModal={true} onCloseModal={() => this.setState({ customerRegister: false })} />
							</Modal.Content>
						</Modal>
                </div>
                <div className="relative">
                  <div className="benefitNumberAbsolute">1</div>
                  <div className="hoverBenefit">
                    

                    <p className="pt4"><svg xmlns="http://www.w3.org/2000/svg" width="61" height="60" viewBox="0 0 61 60" fill="none">
                          <g clipPath="url(#clip0_104_7466)">
                          <path d="M21.5 31.5C9.8 31.5 0.5 40.8 0.5 52.5V55.5H42.5V52.5C42.5 40.8 33.2 31.5 21.5 31.5ZM6.8 49.5C8.3 42.6 14.3 37.5 21.5 37.5C28.7 37.5 34.7 42.6 36.2 49.5H6.8Z" fill="#a2cf66"/>
                          <path d="M21.5 28.5C28.1 28.5 33.5 23.1 33.5 16.5C33.5 9.9 28.1 4.5 21.5 4.5C14.9 4.5 9.5 9.9 9.5 16.5C9.5 23.1 14.9 28.5 21.5 28.5ZM21.5 10.5C24.8 10.5 27.5 13.2 27.5 16.5C27.5 19.8 24.8 22.5 21.5 22.5C18.2 22.5 15.5 19.8 15.5 16.5C15.5 13.2 18.2 10.5 21.5 10.5Z" fill="#a2cf66"/>
                          <path d="M56.2999 18L46.3999 27.9L41.5999 23.4L37.3999 27.6L46.3999 36.6L60.4999 22.2L56.2999 18Z" fill="#a2cf66"/>
                          </g>
                          <defs>
                          <clipPath id="clip0_104_7466">
                          <rect width="60" height="60" fill="white" transform="translate(0.5)"/>
                          </clipPath>
                          </defs>
                          </svg>
                          </p>
                          <p  style={{ textAlign: "center"}} className="pa2 pt3 f4 fw7"> {htmr(translate("benefit_1"))}</p>
                          <p  style={{ textAlign: "center"}} className="pa2 pt1 f5 fw5" >{htmr(translate("benefit_1_desc"))}</p>
                  
                  </div>
                  </div>
                  <div className="relative">
                  <div className="benefitNumberAbsolute">2</div>
                   <div className="hoverBenefit">
                    <p className="pt4"><svg xmlns="http://www.w3.org/2000/svg" width="61" height="60" viewBox="0 0 61 60" fill="none">
                          <g clipPath="url(#clip0_104_7466)">
                          <path d="M21.5 31.5C9.8 31.5 0.5 40.8 0.5 52.5V55.5H42.5V52.5C42.5 40.8 33.2 31.5 21.5 31.5ZM6.8 49.5C8.3 42.6 14.3 37.5 21.5 37.5C28.7 37.5 34.7 42.6 36.2 49.5H6.8Z" fill="#a2cf66"/>
                          <path d="M21.5 28.5C28.1 28.5 33.5 23.1 33.5 16.5C33.5 9.9 28.1 4.5 21.5 4.5C14.9 4.5 9.5 9.9 9.5 16.5C9.5 23.1 14.9 28.5 21.5 28.5ZM21.5 10.5C24.8 10.5 27.5 13.2 27.5 16.5C27.5 19.8 24.8 22.5 21.5 22.5C18.2 22.5 15.5 19.8 15.5 16.5C15.5 13.2 18.2 10.5 21.5 10.5Z" fill="#a2cf66"/>
                          <path d="M56.2999 18L46.3999 27.9L41.5999 23.4L37.3999 27.6L46.3999 36.6L60.4999 22.2L56.2999 18Z" fill="#a2cf66"/>
                          </g>
                          <defs>
                          <clipPath id="clip0_104_7466">
                          <rect width="60" height="60" fill="white" transform="translate(0.5)"/>
                          </clipPath>
                          </defs>
                          </svg>
                          </p>
                          <p  style={{ textAlign: "center"}} className="pa2 pt3 f4 fw7"> {htmr(translate("benefit_2"))}</p>
                          <p  style={{ textAlign: "center"}} className="pa2 pt1 f5 fw5" >{htmr(translate("benefit_2_desc"))}</p>
                  
                  </div>
                  </div>
                  <div className="relative">
                  <div className="benefitNumberAbsolute">3</div>
                   <div className="hoverBenefit">
                    <p className="pt4"><svg xmlns="http://www.w3.org/2000/svg" width="61" height="60" viewBox="0 0 61 60" fill="none">
                          <g clipPath="url(#clip0_104_7466)">
                          <path d="M21.5 31.5C9.8 31.5 0.5 40.8 0.5 52.5V55.5H42.5V52.5C42.5 40.8 33.2 31.5 21.5 31.5ZM6.8 49.5C8.3 42.6 14.3 37.5 21.5 37.5C28.7 37.5 34.7 42.6 36.2 49.5H6.8Z" fill="#a2cf66"/>
                          <path d="M21.5 28.5C28.1 28.5 33.5 23.1 33.5 16.5C33.5 9.9 28.1 4.5 21.5 4.5C14.9 4.5 9.5 9.9 9.5 16.5C9.5 23.1 14.9 28.5 21.5 28.5ZM21.5 10.5C24.8 10.5 27.5 13.2 27.5 16.5C27.5 19.8 24.8 22.5 21.5 22.5C18.2 22.5 15.5 19.8 15.5 16.5C15.5 13.2 18.2 10.5 21.5 10.5Z" fill="#a2cf66"/>
                          <path d="M56.2999 18L46.3999 27.9L41.5999 23.4L37.3999 27.6L46.3999 36.6L60.4999 22.2L56.2999 18Z" fill="#a2cf66"/>
                          </g>
                          <defs>
                          <clipPath id="clip0_104_7466">
                          <rect width="60" height="60" fill="white" transform="translate(0.5)"/>
                          </clipPath>
                          </defs>
                          </svg>
                          </p>
                          <p  style={{ textAlign: "center"}} className="pa2 pt3 f4 fw7"> {htmr(translate("benefit_3"))}</p>
                          <p  style={{ textAlign: "center"}} className="pa2 pt1 f5 fw5" >{htmr(translate("benefit_3_desc"))}</p>
                  </div>
                  </div>
              </div>
              </Responsive>

              <Responsive maxWidth={1199}>
                <div className="flex flex-column items-center">
                <table style={{ backgroundColor: "transparent", border: "none"}}>
                  <tbody>
                    <tr>
                      <td className="fw7 f3 tc"  style={{ textAlign: "center" }}>

                                          <div className="tc">
                <div className="tc pa2 pb3">{translate("Jetzt kostenlos registrieren")}</div>
                <Button
                  style={{ minWidth: "280px", height: "50px", borderRadius: "35px" }}
                  as={Link}
                  to={`/login/?referrer=${document.location.pathname}register`}
                  primary
                  target="_blank"
                  rel="noopener noreferrer"
                ><p className="tc" style={{ margin: 0, display: "flex", alignItems: "center", height: "100%", justifyContent: "center" }}>
                  <Icon name={"large white file text"}/>{translate( "Neukunde" )}
                </p>
                 
                </Button></div>
                      </td>
                      </tr>
                      <tr>
                      <td className="fw7 f3 tc"  style={{ textAlign: "center" }}>
                        <div className="tc pt4">
                          <div className="tc pa2 pb3">{translate("BestandskundeFrage")}</div>
                          <Button
                            style={{ minWidth: "280px", height: "50px", borderRadius: "35px", padding: "10px 20px 10px 20px", }}
                            onClick={() => this.setState({ customerRegister: true })}
                            primary
                          ><p className="tc" style={{ margin: 0, display: "flex", alignItems: "center", height: "100%", justifyContent: "center" }}>
                            <Icon name={"large white file text"}/>{translate( "Zugang anfordern" )}</p>
                          </Button></div>
                        <Modal style={{ borderRadius: 20,}} className="ModalLoginPage"  open={customerRegister} onClose={() => this.setState({ customerRegister: false})}>
                        <Modal.Header>
                        <div className="ml3 flex flex-row justify-between items-center">
                          <div>{translate( "Zugang anfordern" )}</div>
                          <Button basic circular
                              onClick={() => {
                              this.setState({ customerRegister: false})
                              }}
                              icon="times"
                          />
                        </div>
                        
                        </Modal.Header>
                        <Modal.Content>
                              <NewCustomerContactPage closeModal={true} onCloseModal={() => this.setState({ customerRegister: false })} />
                        </Modal.Content>
                      </Modal>
                      </td>
                      </tr>
                  </tbody>
                </table>
                </div>
              </Responsive>
            </section>

                <section className="container pb4 pt5">
                
                <Responsive minWidth={1200}>
                  <p className="f2 fw7 pt2">{translate("Topseller")}</p>
                {<ProductList
                count={4}
                start={0}
                list={productsForList}
                displayMode={"cards"}
                repeat={ProductCard} />}
                </Responsive>
                <Responsive maxWidth={1199} minWidth={900}>
                  <p className="pl3 pr3 f2 fw7 pt2">{translate("Topseller")}</p>
                {<ProductList
                count={4}
                start={0}
                list={productsForList}
                displayMode={"tablet"}
                repeat={ProductCard} />}
                </Responsive>
                <Responsive maxWidth={899}>
                  <div className="flex flex-column items-center">
                  <p className="pl3 pr3 f2 fw7 pt2">{translate("Topseller")}</p>
                {<div className="pl5 pr5 tc flex flex-column items-center justify-center"><ProductList
                count={4}
                start={0}
                list={productsForList}
                displayMode={"mobile"}
                repeat={ProductCard} /></div>}
                </div>
                </Responsive>
            </section>

            <section id="wrapperContact container">

              <div className="sectionCategory">

                <div className="contentArea">
                <CategorySlider 
                firstCategory={categoryforCards1} orderMode={orderMode} style={{zIndex: "9"}} />
                <div className="container pt5">
                </div>
                </div>
              </div>
              </section>

<section>
              <Responsive minWidth={768} maxWidth={1199}>
              <div className="flex flex-row justify-between">
                <div>
                  <div className="pl2 pr2 tc" style={{ textAlign: "left"}}>
                <p className="f5 fw7 black-30">{translate("Unternehmen")}</p>
                <p className="f3 fw7">{translate(`Trendsoft`)}<br/>{translate(`Die Experten für`)}<br/>{translate(`Digitalisierung`)}</p>
                <p className="f1 fw7"></p>
                <p className="f1 fw7"></p>
                <p className="f5 fw5">
                  {translate("Seit über 75 Jahren vertreiben wir Verbrauchsartikel für")}<br/>
                  {translate("Krankenhäuser, Laborbedarf und Mikrobiologie Zubehör –")}<br/>
                  {translate("weltweiter Großhandel und Export, sowie eigene")}<br/>
                  {translate("Produktionen machen unser Geschäft spannend und")}<br/>
                  {translate("vielfältig. Wir sind ein Familienunternehmen – traditionell mit")}<br/>
                  {translate("Mut und Trend zur stetigen Weiterentwicklung und Flexibilität")}<br/>
                  {translate("am Markt- mit Firmensitz in Lingen.")}<br/>
                </p>
                <p className="f5 fw5">
                  {translate("Heute beliefert die Trendsoft Medizinalbedarf GmbH")}<br/>
                  {translate("Kliniken und Labore in über 110 Länder und hat sich mit")} <br/>
                  {translate("zahlreichen Patenten und Schutzmarken weltweit einen")} <br/>
                  {translate("Namen gemacht.")}
                </p>
                <p>
                <Button primary style={{
                  borderRadius: "35px", 
                  height: "60px", 
                  width: "250px", 
                  color: "white",
                  transition: "all 0.3s ease",
                  padding: "10px 20px 10px 20px",
                }} 
                className="ml3 pl3 mr2"
                as={"a"} href="//www.trend-soft.de/produkte/bshop"
                 >
                  <p className="pt2 f4 fw5">{translate("Mehr erfahren")}</p>
                </Button>
                </p>
                </div></div>
                <div>
                  <div className="flex flex-row items-end justify-end">
                  <Image src={currentLanguage === "de" ? "/image/Left.png" : "/image/Left_EN.png"} className="" style={{ maxWidth: "230px", height: "230px" }} />
                  <Image src="/image/globus.png" className="" style={{ maxWidth: "230px", height: "230px" }} />
                  </div>
                  <div className="flex flex-row items-end justify-end" >
                  <Image src="/image/abtupf.png" className="" style={{ maxWidth: "230px", height: "230px" }} />
                  <Image src={currentLanguage === "de" ? "/image/Right.png" : "/image/Right_EN.png"} className="" style={{ maxWidth: "230px", height: "230px" }} />
                  </div></div>
                </div>
                </Responsive>
                <InView triggerOnce>
                  {({ inView, ref }) => (
                    <div  className={inView ? "animate-AboutUs" : "AboutUs"} ref={ref}>
                      
              <Responsive minWidth={1200}>
                <div></div>
                <Table className="tableUeberUns">
              <colgroup>
              <col style={{ width: "40%" }} />
              <col style={{ width: "40%" }} />
              </colgroup>
              <tbody>
              <tr>
                <td className="pl5 tc ">
                <div className="container tc" style={{ textAlign: "left", paddingLeft: "15rem" }}>
                <p className="f4 fw7 black-30">{translate("Unternehmen")}</p>
                <p className="f1 fw7">{translate(`Trendsoft`)}<br/>{translate(`Die Experten für`)}<br/>{translate(`Digitalisierung`)}</p>
                <p className="f1 fw7"></p>
                <p className="f1 fw7"></p>
                <p className="f4 fw5">
                  {translate("Seit über 75 Jahren vertreiben wir Verbrauchsartikel für")}<br/>
                  {translate("Krankenhäuser, Laborbedarf und Mikrobiologie Zubehör –")}<br/>
                  {translate("weltweiter Großhandel und Export, sowie eigene")}<br/>
                  {translate("Produktionen machen unser Geschäft spannend und")}<br/>
                  {translate("vielfältig. Wir sind ein Familienunternehmen – traditionell mit")}<br/>
                  {translate("Mut und Trend zur stetigen Weiterentwicklung und Flexibilität")}<br/>
                  {translate("am Markt- mit Firmensitz in Hamburg.")}<br/>
                </p>
                <p className="f4 fw5">
                  {translate("Heute beliefert die Trendsoft Medizinalbedarf GmbH")}<br/>
                  {translate("Kliniken und Labore in über 110 Länder und hat sich mit")} <br/>
                  {translate("zahlreichen Patenten und Schutzmarken weltweit einen")} <br/>
                  {translate("Namen gemacht.")}
                </p>
                <p>
                <Button primary style={{
                  borderRadius: "35px", 
                  height: "60px", 
                  width: "250px", 
                  color: "white",
                  transition: "all 0.3s ease",
                  padding: "10px 20px 10px 20px",
                }} 
                className="ml3 pl3 mr2"
                as={"a"} href="//www.trend-soft.de/produkte/bshop"
                 >
                  <p className="pt2 f4 fw5">{translate("Mehr erfahren")}</p>
                </Button>
                </p>
                </div>
                </td>
                <td>
                <div className="flex flex-row items-end justify-end">
                  <Image src="/image/headerbild-trendsoft_headerbild.png" className="pa3" style={{ maxWidth: "100%", height: "auto" }} />
                  </div>
                </td>
              </tr>
              </tbody>
                </Table>
              </Responsive>
              <Responsive maxWidth={767}>
              <div className="container tc pa3" style={{ textAlign: "left",}}>
                <p className="f4 fw7 black-30 pl3 pr3">{translate("Unternehmen")}</p>
                <p className="f3 fw7 pl3 pr3">{translate(`Trendsoft:`)}<br/>{translate(`Die Experten für Digitalisierung`)}</p>
                <p className="f5 fw5 pa3 ">
                  {translate("Seit über 75 Jahren vertreiben wir Verbrauchsartikel für")}<br/>
                  {translate("Krankenhäuser, Laborbedarf und Mikrobiologie Zubehör –")}<br/>
                  {translate("weltweiter Großhandel und Export, sowie eigene")}<br/>
                  {translate("Produktionen machen unser Geschäft spannend und")}<br/>
                  {translate("vielfältig. Wir sind ein Familienunternehmen – traditionell mit")}<br/>
                  {translate("Mut und Trend zur stetigen Weiterentwicklung und Flexibilität")}<br/>
                  {translate("am Markt- mit Firmensitz in Hamburg.")}<br/>
                </p>
                <p className="f5 fw5 pl3 pr3">
                  {translate("Heute beliefert die Trendsoft Medizinalbedarf GmbH")}<br/>
                  {translate("Kliniken und Labore in über 110 Länder und hat sich mit")} <br/>
                  {translate("zahlreichen Patenten und Schutzmarken weltweit einen")} <br/>
                  {translate("Namen gemacht.")}
                </p>
                <p className="pa3">
                <Button primary style={{
                  borderRadius: "35px", 
                  height: "60px", 
                  width: "250px", 
                  color: "white",
                  transition: "all 0.3s ease",
                  padding: "10px 20px 10px 20px",
                }} 
                className="ml3 pl3 mr2"
                  as={"a"} href="//www.trend-soft.de/produkte/bshop"
                 >
                  <p className="pt2 f4 fw5">{translate("Mehr erfahren")}</p>
                </Button>
                </p>
                </div>
                 <div className="flex flex-row items-center justify-center">
                  <Image src="/image/headerbild-trendsoft_headerbild.png" className="pa3" style={{ maxWidth: "100%", height: "auto" }} />
                  </div>
              </Responsive>
                    </div>)}
              </InView>
            </section>

<section id="wrapperContact">
            <div className="sectionContact">  

                <div className="container homePageContactSection">
                <div className={`flex ${window.innerWidth < 768 ? "flex-column" : "flex-row"}  justify-between pt5 pb5`}>
                  <div>
                    <div className="pa3">
                    <p className="tc f4 fw5 white">{translate("Trendsoft Vertrieb")}</p>
                    <p className="tc f2 fw7 white">{translate("Neues entdecken.")}<br/>{translate("Informiert bleiben.")} </p>
                    <p className="tc f5 fw4 white-70">{translate("Vereinbaren Sie einen Termin mit unserem Innendienst:")}</p>
                  </div>
                  <div className="pa3 flex flex-column items-center justify-center">
                <Button as={"a"} href={`mailto:vertrieb@trend-soft.de?subject=Anfrage an den Vertriebsinnendienst, Kunde #${shop.session ? shop.session.value.map_id : ''}`}
                  style={{ minWidth: "280px", height: "50px", borderRadius: "35px", boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)" }} primary>{translate("Termin vereinbaren")}</Button>
                  </div>
                </div>
                  <div>
                    <div className="pa3">
                    <p className="tc f4 fw5 white">{translate("Newsletteranmeldung")}</p>
                    <p className="tc f2 fw7 white">{translate("Neues entdecken.")}<br/>{translate("Informiert bleiben.")} </p>
                    <p className="tc f5 fw4 white-70">{translate("Immer einen Schritt voraus – mit unseren Produktnews:")}</p>
                  </div>
                  <div className="pa3 flex flex-column items-center justify-center">
                <Link to={shop.session ? "/account/?referer=_newsletter" : "/login"}><Button 
                  style={{ minWidth: "280px", height: "50px", borderRadius: "35px", boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)"  }} primary>{translate("Anmeldung absenden")}</Button></Link>
                  </div>
                </div>
                <div>
                    <div className="pa3">
                    <p className="tc f4 fw5 white">{translate("Trendsoft Support")}</p>
                    <p className="tc f2 fw7 white">{translate("Software Lösung")}<br/>{translate("Digitalisierung")} </p>
                    <p className="tc f5 fw4 white-70">{translate("Wenn Sie Fragen haben:")}</p>
                  </div>
                  <div className="pa3 flex flex-column items-center justify-center">
                <Button as={"a"} href={`mailto:support@trend-soft.de?subject=Anfrage an den Support, Kunde #${shop.session ? shop.session.value.map_id : ''}`}
                  style={{ minWidth: "280px", height: "50px", borderRadius: "35px", boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)"  }} primary>{translate("Anmeldung absenden")}</Button>
                  </div>
                </div>
                </div>
                </div>

              </div>
            </section>
              </Fragment>}
            {shop.config && shop.config.bShop_Theme && shop.config.bShop_Theme.bshop_frontend_theme == "IceSkating" &&
            <Fragment>
            {<div className="headerImageV3_1 relative">
              <div className="headerImageV3_1--content relative">
                <div className="headerImageV3_1--content-text">
                  <p className="f1 fw6 white">
                    {htmr(translate("Startseitenmeldung"))}
                  </p>
                  <p className="f3 fw5 white-80">
                    {htmr(translate("Startseitenmeldung_2"))}
                  </p>
                  <p>
                    <Button as={"a"} href={"//trend-soft.de/produkte/bshop"} id="moreInfoButton" primary><p className="fw5 f4" style={{textDecoration: "none"}}>{translate("Mehr erfahren")}</p> </Button>
                  </p>
                  </div>
                </div>
              </div>}
              {<div className="headerImageV3_2 relative">
              <div className="headerImageV3_2--content relative">
                <div className="headerImageV3_2--content-text">
                  <p className="f1 fw6 white">
                    {htmr(translate("Startseitenmeldung"))}
                  </p>
                  <p className="f3 fw5 white-80">
                    {htmr(translate("Startseitenmeldung_2"))}
                  </p>
                  <p>
                    <Button as={"a"} href={"//trend-soft.de/produkte/bshop"} id="moreInfoButton" primary><p className="fw5 f4" style={{textDecoration: "none"}}>{translate("Mehr erfahren")}</p> </Button>
                  </p>
                  </div>
                </div>
              </div>}
              {<div className="headerImageV3_3 relative">
              <div className="headerImageV3_3--content relative">
                <div className="headerImageV3_3--content-text">
                  <p className="f1 fw6 white">
                    {htmr(translate("Startseitenmeldung"))}
                  </p>
                  <p className="f3 fw5 white-80">
                    {htmr(translate("Startseitenmeldung_2"))}
                  </p>
                  <p>
                    <Button as={"a"} href={"//trend-soft.de/produkte/bshop"} id="moreInfoButton" primary><p className="fw5 f4" style={{textDecoration: "none"}}>{translate("Mehr erfahren")}</p> </Button>
                  </p>
                  </div>
                </div>
              </div>}
                          <section className="container pb4 pt5">
                
                <Responsive minWidth={1200}>
                  <p className="f2 fw7 pt2">{translate("Topseller")}</p>
                {<ProductList
                count={4}
                start={0}
                list={productsForList.slice(0,4)}
                displayMode={"cards"}
                repeat={ProductCard} />}
                </Responsive>
                <Responsive maxWidth={1199} minWidth={900}>
                  <p className="pl3 pr3 f2 fw7 pt2">{translate("Topseller")}</p>
                {<ProductList
                count={4}
                start={0}
                list={productsForList.slice(0,4)}
                displayMode={"tablet"}
                repeat={ProductCard} />}
                </Responsive>
                <Responsive maxWidth={899}>
                  <div className="flex flex-column items-center">
                  <p className="pl3 pr3 f2 fw7 pt2">{translate("Topseller")}</p>
                {<div className="pl5 pr5 tc flex flex-column items-center justify-center"><ProductList
                count={4}
                start={0}
                list={productsForList.slice(0,4)}
                displayMode={"mobile"}
                repeat={ProductCard} /></div>}
                </div>
                </Responsive>
            </section>
                        <section className="container pb5 pt5">
              <div className="newsLetterSection">
                <p className="f2 fw7 pt2 pb3">{translate("Subscribe")}</p>
                <p className="f3 fw4 black-50" style={{ textAlign: "center"}}>{translate("Bleiben Sie stehts auf dem Laufenden mit den neusten Informationen und Angeboten.")}</p>
                <div className="flex flex-row justify-between items-center mt4">
                  <div className="pr3"><input id="newsLetterMail" type="email" placeholder={translate("Ihre E-Mail Adresse")} className="newsLetterInput pr3" /></div>
                  <div><Button primary style={{ minWidth: "200px", height: "50px", backgroundColor: "#111111"}}><p className="fw5 f4">{translate("Absenden")}</p> </Button></div>
                </div>
             </div>
              </section>
            </Fragment>}
        {shop.config && shop.config.bShop_Theme && shop.config.bShop_Theme.bshop_frontend_theme == "BoldFuture" &&
            <Fragment>
              
            </Fragment>}
        {shop.config && shop.config.bShop_Theme && shop.config.bShop_Theme.bshop_frontend_theme == "LingeringScent" &&
            <Fragment>
            </Fragment>}

            {/*<ImgBanner /> */}
           {/*<HeroSection props={this.props} /> */}

             {/* <SliderHomePage  props={this.props}/> */}
            </div>
        )
    }
}




// WEBPACK FOOTER //
// ./src/theme/demo2025/pages/HomePageV2.js